"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageTitle = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../utils/classFunctions");
require("./index.scss");
const className = 'page-title';
const PageTitle = (props) => {
    const { text, rightSlot, rightSlotHidden, modificators } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("h1", null,
            text,
            (!rightSlot || rightSlotHidden) ? undefined : (react_1.default.createElement("div", { className: `${className}__right` }, rightSlot)))));
};
exports.PageTitle = PageTitle;
//# sourceMappingURL=index.js.map